import store from './../stores'
import axios from 'axios'
import mocks from './mocks'

//import { logout, postError } from './../actions';

/* Setup default headers to use jwt */
/*
axios.interceptors.request.use((config) => {
  let token = store.getState().user.jwt;
  if(token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});
*/

/* Common response for 401 */
/*
axios.interceptors.response.use(undefined, (error) => {
  let res = error.response;
  if (res.status === 401) {
    store.dispatch(logout());
    store.dispatch(postError('Non sei autorizzato, devi effettuare il login.'));
  }
  return Promise.reject(error);
})
*/

export default axios


// WEBPACK FOOTER //
// ./src/sources/AxiosConfig.js